import { use } from 'react'
import { InternalNavigationContext } from './InternalNavigationContext'

export const useAppNavigation = () => use(InternalNavigationContext)
